import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 5.899 13.082 2.44a1.5 1.5 0 0 0-.392-.14 3.8 3.8 0 0 0-1.38 0 1.5 1.5 0 0 0-.392.14L4 5.9m16 0-8 4m8-4 2 3-8 4-2-3m0 0-8-4m8 4-2 3-8-4 2-3M20 10v6.764a2 2 0 0 1-1.106 1.789l-6 3a2 2 0 0 1-1.788 0l-6-3A2 2 0 0 1 4 16.764V10"
    />
  </svg>
);
export const IconOpenBox = withDynamicStroke(Icon);
